import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import WidgetComponent from "../../components/Widget";
import SawasdeeContext from "./SawasdeeContext";
import CheckBoxInsurance from "../../components/CheckBoxInsurance";
import { Accordion } from "react-bootstrap";
import CoverDetails from "../../components/CoverDetailsModal";
import DataService from "../../service/data";
import { TYPE_CODES } from "../../const";
class InternationalStep2 extends Component {
  state = {
    selected: "",
    show: false,
    coverDetails: [],
    medicalExpense: ""
  };
  showModal = () => {
    const { counter } = this.context.step1;
    const { selectedPlan } = this.context.step2;
    const { coverDetails } = this.state;
    this.setState({ show: true }, () => {
      if (coverDetails.length === 0) {
        setTimeout(() => {
          this.initCoverDetail(TYPE_CODES.TS, selectedPlan, counter);
        }, 1000);
      }
    });
  };

  hideModal = () => {
    this.setState({ show: false });
  };
  async initCoverDetail(productCode, selectedPackage, custOrder) {
    try {
      const callers = [];
      callers.push(
        DataService.getCoverDetails({
          product_code: productCode,
          package_code: selectedPackage,
          cust_order: custOrder
        })
      );

      const responses = await Promise.all(callers);

      this.setState({
        ...this.state,
        coverDetails: responses[0]
      });
      // console.log("responses[0]:", responses[0]);
    } catch (err) {
      console.log(err);
    }
  }
  render() {
    const { step1, step2, diffDate = 2 } = this.context;
    const {
      planList = [],
      selectedPlan,
      acceptInsurance,
      acceptHealthCheck,
      onChangeModel
    } = step2;
    const {
      usertype,
      counter
    } = step1;
    const { show, coverDetails } = this.state;
    return (
      <div className="form-wrapper">
        <Accordion
          className="accordion-widget-wrapper"
          defaultActiveKey={selectedPlan}
        >
          {planList.map((item, index) => {
            return (
              <WidgetComponent
                diffDate={diffDate}
                counter={counter}
                key={index}
                listItem={item}
                selected={selectedPlan}
                showModal={this.showModal}
                usertype={usertype}
                onChangePlan={selected =>
                  onChangeModel({ name: "selectedPlan", value: selected })
                }
              />
            );
          })}
          <CoverDetails
            show={show}
            hideModal={this.hideModal}
            listItem={planList} //item
            insurance_type={"ประกันการเดินทางต่างประเทศ"}
            productCode={TYPE_CODES.TS}
            selectedPackage={selectedPlan}
            custOrder={"1"}
            coverDetails={coverDetails}
            onChangeMedical={this.onChangeMedical}
          />
        </Accordion>
        <CheckBoxInsurance
          checked={acceptInsurance}
          checked3={acceptHealthCheck}
          onCheckChange={(name, checked) =>
            onChangeModel({ name: name, value: checked })
          }
        />
      </div>
    );
  }
}
InternationalStep2.contextType = SawasdeeContext;
export default withRouter(InternationalStep2);
